import PropTypes from "prop-types";
import Reveal from "../Reveal/Reveal";
import "./CtaBanner.scss";

const CtaBanner = ({ eyebrow, title, description, children }) => (
  <section className="section">
    <div className="container">
      <Reveal className="cta-banner">
        <div className="cta-banner__glow" aria-hidden="true" />
        <div className="cta-banner__text">
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h2 className="cta-banner__title">{title}</h2>
          {description && <p className="cta-banner__desc">{description}</p>}
        </div>
        <div className="cta-banner__actions">{children}</div>
      </Reveal>
    </div>
  </section>
);

CtaBanner.propTypes = {
  eyebrow: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  children: PropTypes.node,
};

export default CtaBanner;
